import { PostAPI } from 'Components/Helper/Helpers';

export const SenderRegistration = async (request) => {
    return PostAPI(request, 'NovityDMT/SenderRegistration');
};
export const AgentRegistration = async (request) => {
    return PostAPI(request, 'NovityDMT/AgentRegistration');
};

export const SenderRegistrationSubmitOTP = async (request) => {
    return PostAPI(request, 'NovityDMT/SenderRegistrationSubmitOTP');
};

export const SenderRegistrationResendOTP = async (request) => {
    return PostAPI(request, 'NovityDMT/SenderRegistrationResendOTP');
};

export const Select = async (request) => {
    return PostAPI(request, 'NovityDMT/Select');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'NovityDMT/AddBeneficiary');
};

export const DeleteBeneficiary = async (request) => {
    return PostAPI(request, 'NovityDMT/DeleteBeneficiary');
};

export const ViewBeneficiary = async (request) => {
    return PostAPI(request, 'NovityDMT/ViewBeneficiary');
};

export const GetTransctionStatus = async (request) => {
    return PostAPI(request, 'NovityDMT/GetTransctionStatus');
};

export const MoneyTransfer = async (request) => {
    return PostAPI(request, 'NovityDMT/MoneyTransfer');
};

export const SelectBank = async (request) => {
    return PostAPI(request, 'NovityDMT/SelectBank');
};

export const CheckAgentRegistration = async (request) => {
    return PostAPI(request, 'NovityDMT/CheckAgentRegistration');
};

export const VerifyOTPRefund = async (request) => {
    return PostAPI(request, 'NovityDMT/VerifyOTPRefund');
};

export const BeneficiaryOTPValidate = async (request) => {
    return PostAPI(request, 'NovityDMT/BeneficiaryOTPValidate');
};

export const BeneficiaryAddResendOTP = async (request) => {
    return PostAPI(request, 'NovityDMT/BeneficiaryAddResendOTP');
};

export const ValidateDeleteBeneficiaryOTP = async (request) => {
    return PostAPI(request, 'NovityDMT/ValidateDeleteBeneficiaryOTP');
};

export const BeneficiaryDeleteResendOTP = async (request) => {
    return PostAPI(request, 'NovityDMT/BeneficiaryDeleteResendOTP');
};

export const GenerateOTPForSender = async (request) => {
    return PostAPI(request, 'NovityDMT/GenerateOTPForSender');
};

export const AadhaarBiometricForSender = async (request) => {
    return PostAPI(request, 'NovityDMT/AadhaarBiometricForSender');
};

export const GetSplitAmountForTransactionI4Ticket = async (request) => {
    return PostAPI(request, 'NovityDMT/GetSplitAmountForTransactionI4Ticket');
};

export const GenerateOTPForSplitAmountI4Ticket = async (request) => {
    return PostAPI(request, 'NovityDMT/GenerateOTPForSplitAmountI4Ticket');
};

export const AirtelBank2SenderRegistration = async (request) => {
    return PostAPI(
        request,
        'India4TicketAirtelBank2/AirtelBank2SenderRegistration'
    );
};

export const AirtelSenderRegistrationValidateOTP = async (request) => {
    return PostAPI(
        request,
        'India4TicketAirtelBank2/AirtelSenderRegistrationValidateOTP'
    );
};

export const AiretlSenderRegistrationResendOTP = async (request) => {
    return PostAPI(
        request,
        'India4TicketAirtelBank2/AiretlSenderRegistrationResendOTP'
    );
};
export const AirtelBank2SenderEKYC = async (request) => {
    return PostAPI(request, 'India4TicketAirtelBank2/AirtelBank2SenderEKYC');
};

export const NSDLBank3SenderEKYC = async (request) => {
    return PostAPI(request, 'India4TicketNSDLBank3/NSDLBank3SenderEKYC');
};

export const NSDLBank3SenderRegitartion = async (request) => {
    return PostAPI(request, 'India4TicketNSDLBank3/NSDLBank3SenderRegitartion');
};

export const NSDLBankSenderValidateOTP = async (request) => {
    return PostAPI(request, 'India4TicketNSDLBank3/NSDLBankSenderValidateOTP');
};

export const NSDLSenderRegistrationResendOTP = async (request) => {
    return PostAPI(
        request,
        'India4TicketNSDLBank3/NSDLSenderRegistrationResendOTP'
    );
};
